import { useMemo } from "react";
import { useTranslation } from "./useTranslation";

export const useEventTypes = () => {
  const { t } = useTranslation("admin");
  const eventTypes: { value: API.EventType; label: string }[] = useMemo(
    () => [
      { value: "wedding", label: t("wedding") },
      { value: "corporate", label: t("corporate") },
      { value: "birthday", label: t("birthday") },
      { value: "christening", label: t("christening") },
      { value: "other", label: t("other") },
    ],
    [t],
  );
  return eventTypes;
};
